import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "md:flex md:items-center md:justify-end bg-white border-b border-gray-200 flex py-4 pl-8" }
const _hoisted_2 = { class: "flex flex-col md:flex-row mx-auto md:mr-auto md:mx-0" }
const _hoisted_3 = { class: "mt-4 flex-1 flex md:mt-0 md:ml-4 md:pr-8 mx-auto" }
const _hoisted_4 = { class: "py-6" }
const _hoisted_5 = { class: "sm:mx-6 md:mx-8 bg-white shadow overflow-x-auto sm:rounded-md" }
const _hoisted_6 = { class: "shadow overflow-x-auto border-b border-gray-200 sm:rounded-lg" }
const _hoisted_7 = { class: "text-left p-3" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("b", null, "Phone Number", -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode(": ")
const _hoisted_10 = /*#__PURE__*/_createElementVNode("b", null, "Amount", -1)
const _hoisted_11 = /*#__PURE__*/_createTextVNode(": ")
const _hoisted_12 = { class: "w-full" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("b", null, "Slip Date", -1)
const _hoisted_14 = /*#__PURE__*/_createTextVNode(": ")
const _hoisted_15 = ["max"]
const _hoisted_16 = { class: "row text-center text-white" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("p", null, "Submit", -1)
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = { class: "text-left p-3" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("b", null, "Username", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("b", null, "Amount", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("b", null, "Approve Remarks", -1)
const _hoisted_23 = /*#__PURE__*/_createTextVNode(": ")
const _hoisted_24 = { key: 0 }
const _hoisted_25 = ["src"]
const _hoisted_26 = { class: "row text-center text-white" }
const _hoisted_27 = ["disabled"]
const _hoisted_28 = /*#__PURE__*/_createElementVNode("p", null, "Approve", -1)
const _hoisted_29 = ["disabled"]
const _hoisted_30 = /*#__PURE__*/_createElementVNode("p", null, "Reject", -1)

import "dayjs/locale/th";
import dayjs from "dayjs";
import stringify from "qs-stringify";
import localizedFormat from "dayjs/plugin/localizedFormat";
import { AxiosInstance } from "axios";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import { inject, onMounted, ref, shallowRef, watch } from "vue";
import Navbar from "@/components/tools/Navbar.vue";
import DataTable from "@/components/tools/DataTable.vue";
import Pagination from "@/components/tools/Pagination.vue";
import DateSelector from "@/components/tools/DateSelector.vue";
import DepositFilterDialog from "@/components/dialogs/DepositFilterDialog.vue";
import { formatNumber, translate } from "@/utils/tools";

import jwt_decode from "jwt-decode";
import ButtonElement from "@/components/tools/ButtonElement.vue";
import DialogComponent from "@/components/doalog/DialogComponent.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ManualDeposit',
  setup(__props) {

dayjs.extend(localizedFormat);
const axios = inject("$axios") as AxiosInstance;
const store = useStore();
const route = useRoute();
const dataRows = ref([]);
const isLoaded = ref(false);
const advanceFilterModal = ref(false);
const manualDepositModal = ref(false);
const createDepositModal = ref(false);
const depositDate = ref(dayjs().format().slice(0, -9));
const onCheckFuture = (e: any) => {
  const now = dayjs(Date.now());
  const diff = now.diff(e, "second");
  if (diff > 0) return;
  else depositDate.value = dayjs(now).format("YYYY-MM-DDTHH:mm");
};

watch(createDepositModal, (val: any) => {
  console.log('createDepositModal')
  console.log(val)
});
const viewButton = shallowRef(ButtonElement);
const columns = ref([
  {
    label: "phone",
    field: "phone",
    format: (data: any) => data.phone.replace('+66', '0'),
  },
  {
    label: translate("messages.liveTransaction.amount"),
    field: "amount",
    isSorted: false,
    format: (data: any) => formatNumber(data.amount, 100),
    class: (data: any) =>
      Number(data.amount) < 0
        ? "text-red-500"
        : "text-green-500",
  },
  {
    label: "bank_name",
    field: "bank_name",
  },
  {
    label: "bank",
    field: "bank",
  },
  {
    label: "Slip Date",
    field: "requested_at",
    isSorted: false,
    format: (data: any) => dayjs(data.requested_at).locale("th").format("LLL"),
  },
  {
    label: translate("messages.liveTransaction.date"),
    field: "requested_at",
    isSorted: false,
    format: (data: any) => dayjs(data.transfer_time).locale("th").format("LLL"),
  },
  {
    label: translate("messages.withdrawTransaction.status"),
    field: "status",
    // sort: true,
    // isSorted: false,
    format: (data: any) => (data.approve_status ? data.approve_status : "-"),
    class: (data: any) => {
      let base = "text-white rounded ";
      data.approve_status === "REJECTED"
        ? (base += " bg-red-500 ")
        : (base += " bg-yellow-500");

      return base;
    },
  },
  {
    element: viewButton,
    field: "",
    align: "center",
    isFunction: true,
    format: (data: any) => "View",
    function: (data: any) => onViewDepositRequest(data),
    permission: "USER.MANUAL_DEPOSIT_APPROVE",
  },
]);
const pageConfig = ref({
  page: 1,
  count: 0,
  pageCount: 0,
  rowsPerPage: 10,
  dataLength: 0,
  sort: [["created_at", "DESC"]],
});
const filterForm = ref({
  user_phone: null,
  approve_status: null,
  approve_by: null,
  from: null,
  to: null,
  approve_remarks: null,
});
const form = ref();
const preview = ref();
const isLoading = ref(false);

const closeDialog = () => {
  form.value = {};
  manualDepositModal.value = false;
  createDepositModal.value = false;
};
const checkNumberInput = () => {
  form.value.amount = Number(form.value.amount.toFixed(2))
}
const onViewDepositRequest = (data: any) => {
  form.value = data;
  manualDepositModal.value = true;
};
const onOpenCreateDepositRequest = () => {
  form.value = {
    amount: null,
    date_time: null,
    operator_id: store.state.selectedOperator.operatorId,
    admin: store.state.user.username,
    phone: null,
  };
  createDepositModal.value = true;
};
const onCreateDepositRequest = async () => {
  const body = {
    ...form.value,
    amount: `${form.value.amount}`,
    date_time: depositDate.value,
    phone: `${form.value.phone.replace("0", "+66")}`,
  };
  try {
    const res = await axios.post(
      `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/operator-admin/wallet/request-deposit`,
      body
    );
    if (res.data.status === "fail") {
      alert(res.data.result.message);
    } else {
      form.value = {};
      depositDate.value = dayjs().format("YYYY-MM-DDTHH:mm")
      createDepositModal.value = false;
      fetchPageData();
    }
    // phoneNumber.value = "";
  } catch (error) {
    // phoneNumber.value = "";
    form.value = {};
    createDepositModal.value = false;
    alert(error);
    fetchPageData();
  }
};
const onApproveManualDeposit = async (approve_status: string) => {
  isLoading.value = true;
  const body = {
    deposit_id: form.value.id,
    operator_id: store.state.selectedOperator.operatorId,
    phone: form.value.phone,
    admin_id: store.state.user.id,
    approve_status: approve_status,
    approve_remarks: form.value.approve_remarks,
  };
  try {
    await axios.post(
      `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/operator-admin/wallet/approve-deposit`,
      body
    );
    form.value = {};
    manualDepositModal.value = false;
    // phoneNumber.value = "";
    isLoading.value = false;
    fetchPageData();
  } catch (error) {
    // phoneNumber.value = "";
    form.value = {};
    manualDepositModal.value = false;
    alert(error);
    isLoading.value = false;
    fetchPageData();
  }
};
// const onRejectManualDeposit = async () => {
//   isLoaded.value = true;
//   }
// };

const filterModal = (data = { flag: 0, chanel: null }) => {
  advanceFilterModal.value = !advanceFilterModal.value;
  if (data.flag == 1) {
    pageConfig.value.page = 1;
    // filterForm.value.channel = data.chanel;
    fetchPageData();
  }
};
const doSort = (attName: string) => {
  const index = columns.value.findIndex((column) => column.label === attName);

  columns.value[index].isSorted = !columns.value[index].isSorted;

  const { sort } = pageConfig.value;
  const mode = sort[0][1];
  if (attName === "Date") attName = "seq_num";
  sort[0] = [attName.toLowerCase(), mode === "DESC" ? "ASC" : "DESC"];

  fetchPageData();
};
const fetchPageData = async () => {
  isLoaded.value = false;
  const { page, rowsPerPage, sort } = pageConfig.value;
  const { user_phone, approve_status, approve_by, from, to } = filterForm.value;
  const payload: any = {
    operator_id: store.state.selectedOperator.operatorId,
    start_date: from
      ? dayjs(from).format("YYYY-MM-DD")
      : dayjs().add(-1, "month").format("YYYY-MM-DD"),
    end_date: to
      ? dayjs(to).add(1, "day").format("YYYY-MM-DD")
      : dayjs().add(1, "day").format("YYYY-MM-DD"),
    limit: rowsPerPage,
    offset: (page - 1) * rowsPerPage,
    type: "DEPOSIT",
    approve_status: "PENDING",
    sort: sort,
  };

  const url = `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/operator-admin/wallet/deposit-transactions`;
  // const url = `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/operator-admin/wallet/deposit-transactions`;
  const { data } = await axios.post(url, payload).then((data) => data);

  pageConfig.value.dataLength = data.rows.length;
  pageConfig.value.count = data.rows.length;

  dataRows.value = data.rows;

  // pageConfig.value = {
  //   ...pageConfig.value,
  //   // count,
  //   // pageCount: Math.ceil(count / rowsPerPage),
  // };
  /** update url to persist page config */
  //   window.history.replaceState(
  //     {},
  //     document.title,
  //     `deposit?${stringify({ page, rowsPerPage })}`
  //   );
  isLoaded.value = true;
};
const onSearch = (payload: { from: null; to: null }) => {
  filterForm.value.from = payload.from;
  filterForm.value.to = payload.to;
  fetchPageData();
};

onMounted(() => {
  pageConfig.value.page = Number(route.query.page) || 1;
  pageConfig.value.rowsPerPage = Number(route.query.rowsPerPage) || 10;
  fetchPageData();
});
/** fetch data when current page was changed */
watch(
  () => pageConfig.value.page,
  () => fetchPageData()
);
/** fetch data when rows per page was changed */
watch(
  () => pageConfig.value.rowsPerPage,
  () => {
    pageConfig.value.page = 1;
    fetchPageData();
  }
);

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createVNode(Navbar, {
        title: _ctx.$t('messages.manualDepositWithdraw.manualDeposit')
      }, null, 8, ["title"]),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(DateSelector, { onSearch: onSearch }),
          _createElementVNode("div", _hoisted_3, [
            (_unref(store).state.user.permissions.includes('USER.MANUAL_DEPOSIT_CREATE'))
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (onOpenCreateDepositRequest())),
                  class: "md:ml-3 inline-flex items-center px-3 py-1 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-green-500 hover:bg-green-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-white focus:ring-green-500"
                }, " Create Deposit Request "))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(DataTable, {
              columns: columns.value,
              data: dataRows.value,
              onSort: doSort,
              isLoaded: isLoaded.value
            }, null, 8, ["columns", "data", "isLoaded"]),
            _createVNode(Pagination, {
              config: pageConfig.value,
              "onUpdate:config": _cache[1] || (_cache[1] = ($event: any) => ((pageConfig).value = $event))
            }, null, 8, ["config"])
          ])
        ])
      ])
    ]),
    _createVNode(DialogComponent, {
      isOpen: createDepositModal.value,
      "onUpdate:isOpen": _cache[5] || (_cache[5] = ($event: any) => ((createDepositModal).value = $event)),
      title: "Create Deposit Request"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("p", null, [
            _hoisted_8,
            _hoisted_9,
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.phone) = $event)),
              type: "text",
              placeholder: "input user phone number",
              class: "rounded my-3 w-full"
            }, null, 512), [
              [_vModelText, form.value.phone]
            ])
          ]),
          _createElementVNode("p", null, [
            _hoisted_10,
            _hoisted_11,
            _withDirectives(_createElementVNode("input", {
              type: "number",
              placeholder: "input amount",
              class: "rounded my-3 w-full",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.value.amount) = $event)),
              onInput: checkNumberInput
            }, null, 544), [
              [_vModelText, form.value.amount]
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _hoisted_14,
            _withDirectives(_createElementVNode("input", {
              id: "depositDate",
              "onUpdate:modelValue": [
                _cache[4] || (_cache[4] = ($event: any) => ((depositDate).value = $event)),
                onCheckFuture
              ],
              placeholder: "Deposit Date",
              type: "datetime-local",
              max: _unref(dayjs)().format().slice(0, -6),
              class: "rounded my-3 w-full",
              name: "depositDate"
            }, null, 8, _hoisted_15), [
              [_vModelText, depositDate.value]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("button", {
            onClick: closeDialog,
            class: "rounded bg-gray-500 p-2 m-1"
          }, " Cancel "),
          (_unref(store).state.user.permissions.includes('USER.MANUAL_DEPOSIT_CREATE'))
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "rounded bg-blue-500 p-2 m-1",
                onClickOnce: onCreateDepositRequest
              }, _hoisted_18, 32))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["isOpen"]),
    _createVNode(DialogComponent, {
      isOpen: manualDepositModal.value,
      title: "Confirm Approve Deposit"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("p", null, [
            _hoisted_20,
            _createTextVNode(": " + _toDisplayString(form.value.phone), 1)
          ]),
          _createElementVNode("p", null, [
            _hoisted_21,
            _createTextVNode(": " + _toDisplayString((Number(form.value.amount) / 100).toFixed(2)), 1)
          ]),
          _createElementVNode("p", null, [
            _hoisted_22,
            _hoisted_23,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              placeholder: "input approve remarks",
              class: "rounded my-3 w-full",
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.value.approve_remarks) = $event))
            }, null, 512), [
              [_vModelText, form.value.approve_remarks]
            ])
          ])
        ]),
        _createElementVNode("div", null, [
          (preview.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                _createElementVNode("img", {
                  src: preview.value,
                  class: "mx-auto w-52 h-52 object-contain"
                }, null, 8, _hoisted_25)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("button", {
            onClick: closeDialog,
            class: "rounded bg-gray-500 p-2 m-1"
          }, " Cancel "),
          (_unref(store).state.user.permissions.includes('USER.MANUAL_DEPOSIT_APPROVE'))
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "rounded bg-blue-500 p-2 m-1",
                disabled: !isLoaded.value,
                onClickOnce: _cache[7] || (_cache[7] = ($event: any) => (onApproveManualDeposit('APPROVED')))
              }, [
                (isLoading.value)
                  ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                      key: 0,
                      class: "text-gray-500",
                      icon: ['fas', 'circle-notch'],
                      transform: "grow-6",
                      spin: ""
                    }))
                  : _createCommentVNode("", true),
                _hoisted_28
              ], 40, _hoisted_27))
            : _createCommentVNode("", true),
          (_unref(store).state.user.permissions.includes('USER.MANUAL_DEPOSIT_APPROVE'))
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: "rounded bg-red-500 p-2 m-1",
                disabled: !isLoaded.value,
                onClickOnce: _cache[8] || (_cache[8] = ($event: any) => (onApproveManualDeposit('REJECTED')))
              }, [
                (isLoading.value)
                  ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                      key: 0,
                      class: "text-gray-500",
                      icon: ['fas', 'circle-notch'],
                      transform: "grow-6",
                      spin: ""
                    }))
                  : _createCommentVNode("", true),
                _hoisted_30
              ], 40, _hoisted_29))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["isOpen"]),
    _createVNode(DepositFilterDialog, {
      class: "z-10",
      show: advanceFilterModal.value,
      "onUpdate:show": _cache[9] || (_cache[9] = ($event: any) => ((advanceFilterModal).value = $event)),
      form: filterForm.value,
      "onUpdate:form": _cache[10] || (_cache[10] = ($event: any) => ((filterForm).value = $event)),
      onSubmit: filterModal
    }, null, 8, ["show", "form"])
  ], 64))
}
}

})